module.exports = __webpack_public_path__ + "img/about-direct-school.c46462d1.svg";